import './newsletter-subscription.scss';

import axios from 'axios';
import { checkAndLoadFiles, createElementFromHTML } from './../../utilities/js/helper';

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$newsletterSubscriptionLink = $context.querySelectorAll('[data-newslettersubscription="root"]');
        for (let i = 0; i < $$newsletterSubscriptionLink.length; i++) {
            const $newsletterSubscriptionLink = $$newsletterSubscriptionLink[i];
            const uri = $newsletterSubscriptionLink.getAttribute('data-href');

            if (uri) {
                axios({
                    method: 'GET',
                    url: uri
                })
                    .then((result) => {
                        if (result && result.data) {
                            const $result = createElementFromHTML(result.data);
                            $newsletterSubscriptionLink.replaceWith($result);

                            const contentUpdateEvent = new CustomEvent('content.loaded', {
                                view: window,
                                bubbles: true,
                                cancelable: false,
                                detail: {
                                    $context: $result
                                }
                            });
                            window.dispatchEvent(contentUpdateEvent);
                            checkAndLoadFiles($result);
                            window.checkInview(window.eventScroller);
                        }
                    })
                    .catch((error) => {
                        throw Error(error);
                    });
            }
        }
    }
});
